import api from './client.js'

/* Overlay-kanalen (F1) — regie beheert stabiele slugs die OBS opent als
   browser-source. Wat er in het kanaal getoond wordt (welke server, welke
   match, welke layout) wisselt live zonder OBS-refresh. */
export const overlayAPI = {
  channels:      ()             => api.get('/overlay/channels'),
  channelState:  (slug)         => api.get(`/overlay/channels/${slug}/state`),
  createChannel: (body)         => api.post('/overlay/channels', body),
  updateChannel: (id, body)     => api.patch(`/overlay/channels/${id}`, body),
  deleteChannel: (id)           => api.delete(`/overlay/channels/${id}`),

  // Beheer / debug
  listActive:    ()             => api.get('/overlay/list'),
}
